import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextDescriptionPipe } from './text-decoration/text-description.pipe';
import { IsADatePipe } from './is-a-date/is-a-date.pipe';
import { FormatDatePipe } from './format-date/format-date.pipe';
import { ReplacePipe } from './replace/replace.pipe';
import { ShufflePipe } from './shuffle-pipe';

@NgModule({
  declarations:
  [
    TextDescriptionPipe,
    IsADatePipe,
    FormatDatePipe,
    ReplacePipe,
    ShufflePipe,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    TextDescriptionPipe,
    IsADatePipe,
    FormatDatePipe,
    ReplacePipe,
    ShufflePipe,
  ]
})
export class PipesModule {}
